<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">

                                <mat-tab-group mat-align-tabs="start" #tabGroup
                  >
                  <mat-tab label="Informations">

                    <div class="row" style="padding: 10px;">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                        style="padding-left: 5px; padding-right: 5px;position:relative">
                        <label (click)="onPenDetailModal('','garant')"
                            [ngClass]="{'isSelectedItem':itemToSave.garant_id}">Garant :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="on_change_garant()" [(ngModel)]="itemToSave.garant_id"
                            placeholder="Choisissez " name="garant_id" id="garant_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalGarantComponent()"><i
                                class="fa fa-plus"></i></button>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position:relative;">
                        <label (click)="onPenDetailModal('','souscripteur')"
                            [ngClass]="{'isSelectedItem':itemToSave.souscripteur_id}">Souscripteur :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.souscripteur_id" placeholder="Choisissez "
                            name="souscripteur_id" id="souscripteur_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalSouscripteurComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date éffet :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                            onkeydown="return false" -->
                        <input type="text" placeholder="Date éffet" autocomplete="off" class="form-control" bsDatepicker
                            [bsConfig]="{
                                              dateInputFormat: 'DD/MM/YYYY',
                                              containerClass: 'theme-dark-blue'
                                            }" [(ngModel)]="itemToSave.date_effet" name="date_effet" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date échéance :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                            onkeydown="return false" -->
                        <input type="text" placeholder="Date échéance" autocomplete="off" class="form-control"
                            bsDatepicker [bsConfig]="{
                                              dateInputFormat: 'DD/MM/YYYY',
                                              containerClass: 'theme-dark-blue'
                                            }" [(ngModel)]="itemToSave.date_echeance" name="date_echeance" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Plafond :
                            <span class="required_champs">*</span>
                        </label>
                        <input mask="separator" class="form-control custom-input" placeholder="Plafond"
                            autocomplete="off" [(ngModel)]="itemToSave.plafond" name="plafond" autocomplete="off"
                            type="text" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Catégorie :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.categorie_police_id" placeholder="Choisissez "
                            name="categorie_police_id" id="categorie_police_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCategoriePolice" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                    </div>



                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Type remboursement :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectTypeRemboursement()" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.type_remboursement_id" placeholder="Choisissez "
                            name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Taux tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Taux tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_tpg" name="taux_tpg" autocomplete="off"
                            type="text" mask="separator" />

                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Majoration tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Majoration tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.majoration_tpg" name="majoration_tpg"
                            autocomplete="off" type="text" mask="separator" />

                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Plafond tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Plafond tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.plafond_tpg" name="plafond_tpg"
                            autocomplete="off" type="text" mask="separator" />

                    </div>

                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;position: relative;">
                        <label>Souscripteur :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.souscripteur_id" placeholder="Choisissez "
                            name="souscripteur_id" id="souscripteur_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button disabled class="btn btn-success btn-quick-add" (click)="openModalAddSouscripteur()"><i
                            class="fa fa-plus"></i></button>
                    </div> -->


                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Code:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" [disabled]="itemToSave.id" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemToSave.code" name="code" autocomplete="off"
                            type="text" />
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Codification:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Codification" autocomplete="off"
                            [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Numéro interne:
                        </label>
                        <input class="form-control custom-input" placeholder="Numéro interne" autocomplete="off"
                            [(ngModel)]="itemToSave.numero_interne" name="numero_interne" autocomplete="off"
                            type="text" />
                    </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Numéro externe:
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Numéro externe" autocomplete="off"
                            [(ngModel)]="itemToSave.numero_externe" name="numero_externe" autocomplete="off"
                            type="text" />
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux de couverture :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Taux de couverture" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_couverture" name="taux_couverture" autocomplete="off" type="text" mask="separator" />
                    </div> -->



                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission sinistre :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.forfait_commission_sinistre >0" mask="separator"
                            class="form-control custom-input" placeholder="Taux commission sinistre" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_sinistre" name="taux_commission_sinistre"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission sinistre :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.taux_commission_sinistre>0" mask="separator"
                            class="form-control custom-input" placeholder="Forfait commission sinsitre"
                            autocomplete="off" [(ngModel)]="itemToSave.forfait_commission_sinistre"
                            name="forfait_commission_sinistre" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission prime :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.forfait_commission_prime>0" mask="separator"
                            class="form-control custom-input" placeholder="Taux commission prime" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_prime" name="taux_commission_prime"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission prime :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.taux_commission_prime>0" mask="separator"
                            class="form-control custom-input" placeholder="Forfait commission prime" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_prime" name="forfait_commission_prime"
                            autocomplete="off" type="text" />
                    </div> -->

                    
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','courtier')"
                            [ngClass]="{'isSelectedItem':itemToSave.courtier_id}">Courtier :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.courtier_id" placeholder="Choisissez " name="courtier_id"
                            id="courtier_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCourtier" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission courtier(%) :
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_courtier=''"
                            class="form-control custom-input" placeholder="Taux commission courtier" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_courtier" name="taux_commission_courtier"
                            autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission courtier(%) :
                        </label>
                        <input (input)="itemToSave.forfait_commission_courtier=''" class="form-control custom-input"
                            placeholder="Forfait commission courtier" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_courtier" name="forfait_commission_courtier"
                            autocomplete="off" type="text" mask="separator">
                    </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','intermediaire')"
                            [ngClass]="{'isSelectedItem':itemToSave.intermediaire_id}">Intermédiaire :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.intermediaire_id" placeholder="Choisissez "
                            name="intermediaire_id" id="intermediaire_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsIntermediaire" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission intermédiaire(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_intermediaire=''"
                            class="form-control custom-input" placeholder="Taux commission intermédiaire"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_commission_intermediaire"
                            name="taux_commission_intermediaire" autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission intermédiaire(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input (input)="itemToSave.forfait_commission_intermediaire=''"
                            class="form-control custom-input" placeholder="Forfait commission intermediaire"
                            autocomplete="off" [(ngModel)]="itemToSave.forfait_commission_intermediaire"
                            name="forfait_commission_intermediaire" autocomplete="off" type="text" mask="separator">
                    </div>
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','apporteur')"
                            [ngClass]="{'isSelectedItem':itemToSave.apporteur_id}">Apporteur :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.apporteur_id" placeholder="Choisissez " name="apporteur_id"
                            id="apporteur_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsApporteur" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission apporteur (%) :
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_apporteur=''"
                            class="form-control custom-input" placeholder="Taux commission apporteur" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_apporteur" name="taux_commission_apporteur"
                            autocomplete="off" type="text">
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission apporteur(%) :
                        </label>
                        <input (input)="itemToSave.forfait_commission_apporteur=''" class="form-control custom-input"
                            placeholder="Forfait commission apporteur" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_apporteur" name="forfait_commission_apporteur"
                            autocomplete="off" type="text" mask="separator">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position:relative">
                        <label (click)="onPenDetailModal('','commercial')"
                            [ngClass]="{'isSelectedItem':itemToSave.commerciale_id}">Commercial :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.commerciale_id" placeholder="Choisissez "
                            name="commerciale_id" id="commerciale_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+'
                                '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCommercialComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission commercial(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input mask="000" (input)="itemToSave.forfait_commission_commercial=''"
                            class="form-control custom-input" placeholder="Taux commission commercial"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_commission_commercial"
                            name="taux_commission_commercial" autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission commercial(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input (input)="itemToSave.taux_commission_commercial_id=''" class="form-control custom-input"
                            placeholder="Forfait commission commercial" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_commercial" name="forfait_commission_commercial"
                            autocomplete="off" type="text" mask="separator">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Délai de carence (jours) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Délai de carence" autocomplete="off"
                            [(ngModel)]="itemToSave.delai_carence" name="delai_carence" autocomplete="off" type="text"
                            mask="separator">
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil alerte consommation (%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil alerte conso" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_alerte_conso" name="seuil_alerte_conso" autocomplete="off"
                            type="text" />
                    </div>



                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil suspension tiers payant (%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil suspension tp" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_suspension_tiers_payant" name="seuil_suspension_tiers_payant"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>A qui rembourser? :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.assure_remboursement" placeholder="Choisissez "
                            name="assure_remboursement" id="assure_remboursement" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsRemboursement" [value]="item.code">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode tarification :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                            name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode reconduction :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_reconduction_id" placeholder="Choisissez "
                            name="mode_reconduction_id" id="mode_reconduction_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeReconduction" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode fractionnement :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_fractionnement_id" placeholder="Choisissez "
                            name="mode_fractionnement_id" id="mode_fractionnement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeFractionnement" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label (click)="openModalPrestataireReseau()"
                            [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.reseau_de_soin_id" placeholder="Choisissez "
                            name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Tarif :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.tarif_id" placeholder="Choisissez " name="tarif_id"
                            id="tarif_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTarif" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>



                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Statut :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.statut_police_id" placeholder="Choisissez "
                            name="statut_police_id" id="statut_police_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsStatutPolice" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode gestion avenant :
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.mode_gest_avenant" placeholder="Choisissez "
                            name="mode_gest_avenant" id="mode_gest_avenant" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsListeModeGestAvenant" [value]="item.value">{{
                                item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Périodicité avenant :
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.periodicite_avenant" placeholder="Choisissez "
                            name="periodicite_avenant" id="periodicite_avenant" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsPeriodiciteAvenant" [value]="item.value">{{ item.libelle
                                }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_prorata_prime" id="is_prorata_prime" name="is_prorata_prime"
                            autocomplete="off" type="checkbox" />
                        <label for="is_prorata_prime">Prorata prime?
                        </label>
                        <ng-select *ngIf="itemToSave.is_prorata_prime" [(ngModel)]="itemToSave.mode_prorata_id"
                            placeholder="Choisissez mode prorata " name="mode_prorata_id" id="statut_garant_id"
                            [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeProrata" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- Accessoire police -->
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1" style="padding-left: 5px;">
                        <input [(ngModel)]="itemToSave.is_accessoire_police" id="is_accessoire_police"
                            name="is_accessoire_police" type="checkbox" />
                        <label for="is_accessoire_police" class="ml-1"><strong>Accessoire police ?</strong></label>
                    </div>

                    <ng-container *ngIf="itemToSave.is_accessoire_police">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Avenants accessoire :</label>
                            <ng-select [(ngModel)]="itemToSave.avenant_accessoire" name="avenant_accessoire"
                                [multiple]="true" [closeOnSelect]="false" [clearable]="true" placeholder="Choisissez">
                                <ng-option *ngFor="let item of itemsTypeAvenantAccessoire" [value]="item.codification">
                                    {{ item.libelle }}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Forfait accessoire garant :</label>
                            <input class="form-control custom-input" placeholder="Forfait garant"
                                [(ngModel)]="itemToSave.forfait_accessoire_garant" name="forfait_accessoire_garant"
                                type="text" mask="separator" />
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Taux accessoire garant (%) :</label>
                            <input class="form-control custom-input" placeholder="Taux garant"
                                [(ngModel)]="itemToSave.taux_accessoire_garant" name="taux_accessoire_garant"
                                type="text" mask="separator" />
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Forfait accessoire gestionnaire :</label>
                            <input class="form-control custom-input" placeholder="Forfait gestionnaire"
                                [(ngModel)]="itemToSave.forfait_accessoire_gestionnaire" name="forfait_accessoire_gestionnaire"
                                type="text" mask="separator" />
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Forfait accessoire intermédiaire :</label>
                            <input class="form-control custom-input" placeholder="Forfait intermédiaire"
                                [(ngModel)]="itemToSave.forfait_accessoire_intermediaire" name="forfait_accessoire_intermediaire"
                                type="text" mask="separator" />
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;">
                            <label>Taux accessoire intermédiaire (%) :</label>
                            <input class="form-control custom-input" placeholder="Taux intermédiaire"
                                [(ngModel)]="itemToSave.taux_accessoire_intermediaire" name="taux_accessoire_intermediaire"
                                type="text" mask="separator" />
                        </div>
                    </ng-container>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_acte_visible"
                            id="is_attente_prealable_acte_visible" name="is_attente_prealable_acte_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_acte_visible">Acte entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_acte_visible" id="is_non_garantie_acte_visible"
                            name="is_non_garantie_acte_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_acte_visible">Actes non garantis visibles?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_medoc_visible"
                            id="is_attente_prealable_medoc_visible" name="is_attente_prealable_medoc_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_medoc_visible">Médoc entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_medoc_visible" id="is_non_garantie_medoc_visible"
                            name="is_non_garantie_medoc_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_medoc_visible">Médoc non garantie visible?
                        </label>


                    </div> -->



                </div>
                   
                  </mat-tab>
                  <mat-tab label="Données de facturation">
                    <div style="overflow-x: hidden; padding: 12px 4px;">

                        <!-- Mode de facturation -->
                        <div class="fact-section mb-3">
                            <div class="fact-section-header fact-mode">
                                <i class="fa fa-cogs mr-2"></i> Mode de facturation
                            </div>
                            <div class="fact-section-body">
                                <div class="d-flex align-items-center">
                                    <mat-slide-toggle
                                        [(ngModel)]="itemToSave.is_facturation_autonome"
                                        name="is_facturation_autonome"
                                        [disabled]="isDetailMode">
                                        Facturation autonome (police facturée directement au souscripteur)
                                    </mat-slide-toggle>
                                </div>
                                <small class="text-muted" style="font-size:11px;">
                                    Si activé, les paramètres ci-dessous s'appliquent à cette police uniquement et la facture sera adressée au souscripteur (et non au garant).
                                </small>
                            </div>
                        </div>

                        <div class="row">

                            <!-- ===== Colonne gauche : Caution + Sinistre + Déficit ===== -->
                            <div class="col-md-6">

                                <!-- Facture caution garantie -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-caution">
                                        <i class="fa fa-shield-alt mr-2"></i> Facture caution garantie
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Fraction caution démarrage (Nbr/12)</label>
                                                <input
                                                    matTooltip="Fraction Caution = Nb mois / 12. Une fraction (très souvent 2/12) des sinistres. Quand il s'agit d'un démarrage, les sinistres sont estimés (provision de sinistre) et on applique 2/12 pour obtenir la caution de démarrage."
                                                    class="form-control form-control-sm"
                                                    placeholder="Fraction caution" autocomplete="off"
                                                    [(ngModel)]="itemToSave.fraction_caution"
                                                    name="fraction_caution" type="text" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Source fond caution permanente</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Le montant que le garant dépose comme garantie au gestionnaire. Ce montant peut provenir n/12ième des sinistres provisionnés ou d'un forfait."
                                                    [(ngModel)]="itemToSave.source_fond_caution_permanente"
                                                    placeholder="Choisissez" name="source_fond_caution_permanente"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeSourceFondCaution()">
                                                    <ng-option *ngFor="let item of itemsSourceFondCaution"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2"
                                                *ngIf="itemToSave.source_fond_caution_permanente !== 'FORFAIT'">
                                                <label class="fact-label">Assiette fond caution garantie</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Que la source de caution soit forfait ou provision de sinistre, il faut indiquer l'assiette : par garant (nombre=1), par famille (nombre de familles) ou par bénéficiaire (nombre d'individus)."
                                                    [disabled]="isDetailMode"
                                                    [(ngModel)]="itemToSave.assiete_fond_caution_permanente"
                                                    placeholder="Choisissez" name="assiete_fond_caution_permanente"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeAssieteCaution()">
                                                    <ng-option *ngFor="let item of assietteDeFond"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2"
                                                *ngIf="itemToSave.source_fond_caution_permanente === 'FORFAIT'">
                                                <label class="fact-label">Forfait caution permanente</label>
                                                <input
                                                    matTooltip="Si la source de fond de caution permanente est un forfait, on renseigne ce montant (HT)."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Forfait caution permanente" autocomplete="off"
                                                    [(ngModel)]="itemToSave.forfait_caution_permanente"
                                                    name="forfait_caution_permanente" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Seuil complément caution (%)</label>
                                                <input
                                                    matTooltip="Soit n le seuil, k la fraction de caution, s le cumul des sinistres de l'année écoulée et c la caution actuelle. C2 = k/12 × s. Si Δc (C2-C) > n×C/100, une facture complémentaire de Δc est adressée."
                                                    class="form-control form-control-sm"
                                                    placeholder="Seuil complément caution" autocomplete="off"
                                                    [(ngModel)]="itemToSave.seuil_complement_caution"
                                                    name="seuil_complement_caution" type="text" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Périodicité caution</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Fréquence d'émission de la facture caution (mensuelle, trimestrielle, semestrielle, annuelle)."
                                                    [(ngModel)]="itemToSave.periodicite_caution"
                                                    placeholder="Choisissez" name="periodicite_caution"
                                                    [multiple]="false" [closeOnSelect]="true">
                                                    <ng-option *ngFor="let item of periodicite"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Facture sinistre -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-sinistre">
                                        <i class="fa fa-file-medical mr-2"></i> Facture sinistre
                                        <small class="ml-2 font-weight-normal" style="font-size:11px; opacity:0.85;">(remboursement des dépenses des assurés)</small>
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Source fond sinistre</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Provision sinistres : le gestionnaire encaisse une avance par précaution. Sinistres réels : le gestionnaire facture au fur et à mesure."
                                                    [disabled]="isDetailMode"
                                                    [(ngModel)]="itemToSave.source_fond_sinistre"
                                                    placeholder="Choisissez" name="source_fond_sinistre"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeSourceFondSinistre()">
                                                    <ng-option *ngFor="let item of itemsSourceFondSinistre"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">
                                                    Assiète fond sinistre
                                                    <span class="fact-badge-forced"
                                                        *ngIf="itemToSave.source_fond_sinistre === 'SINISTRE-REEL'">Forcé : Aucune</span>
                                                </label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="La base de calcul : Par garant (nombre=1), Par famille (nombre de familles), Par bénéficiaire (nombre d'individus)."
                                                    [disabled]="isDetailMode || itemToSave.source_fond_sinistre === 'SINISTRE-REEL'"
                                                    [(ngModel)]="itemToSave.assiete_fond_sinistre"
                                                    placeholder="Choisissez" name="assiete_fond_sinistre"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeAssieteSinistre()">
                                                    <ng-option *ngFor="let item of assietteDeFond"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Périodicité fond sinistre</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Fréquence d'établissement de factures de sinistres."
                                                    [(ngModel)]="itemToSave.periodicite_fond_sinistre"
                                                    placeholder="Choisissez" name="periodicite_fond_sinistre"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangePeriodiciteFondSinistre()">
                                                    <ng-option *ngFor="let item of periodicite"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Taux commission provision sinistre (%)</label>
                                                <input
                                                    matTooltip="Taux appliqué aux sinistres (provisionnés ou réalisés) pour le calcul des honoraires."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Taux commission provision sinistre" autocomplete="off"
                                                    [(ngModel)]="itemToSave.taux_commission_prov_sinistre"
                                                    name="taux_commission_prov_sinistre" type="text" mask="separator" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Facture déficit -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-deficit">
                                        <i class="fa fa-balance-scale mr-2"></i> Facture déficit
                                        <small class="ml-2 font-weight-normal" style="font-size:11px; opacity:0.85;">(provision épuisée ou insuffisante)</small>
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Périodicité facturation déficit</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Quand la provision est épuisée ou insuffisante, le gestionnaire adresse une facture de déficit pour réclamer la différence (sinistres réels – provision encaissée)."
                                                    [(ngModel)]="itemToSave.periodicite_deficit"
                                                    placeholder="Choisissez" name="periodicite_deficit"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangePeriodiciteDeficit()">
                                                    <ng-option *ngFor="let item of periodicite"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <!-- ===== Colonne droite : Honoraire + Taux + Estimations ===== -->
                            <div class="col-md-6">

                                <!-- Facture honoraire -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-honoraire">
                                        <i class="fa fa-hand-holding-usd mr-2"></i> Facture honoraire
                                        <small class="ml-2 font-weight-normal" style="font-size:11px; opacity:0.85;">(rémunération du gestionnaire)</small>
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Source fond honoraire</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Prime (commission sur primes d'assurance) | Provisions sinistres (taux sur sinistres provisionnés) | Forfait (montant fixe convenu) | Sinistres réels (taux appliqué au sinistre réel)."
                                                    [disabled]="isDetailMode"
                                                    [(ngModel)]="itemToSave.source_fond_honoraire"
                                                    placeholder="Choisissez" name="source_fond_honoraire"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeSourceFondHonoraire()">
                                                    <ng-option *ngFor="let item of itemsSourceFondHonoraire"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2"
                                                *ngIf="itemToSave.source_fond_honoraire === 'FORFAIT'">
                                                <label class="fact-label">Forfait fond honoraire (HT) <span class="required_champs">*</span></label>
                                                <input
                                                    matTooltip="Si source = Forfait, préciser ici le montant du forfait (HT) servant de base au calcul des honoraires."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Forfait fond honoraire" autocomplete="off"
                                                    [(ngModel)]="itemToSave.forfait_fond_honoraire"
                                                    name="forfait_fond_honoraire" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">
                                                    Assiète fond honoraire
                                                    <span class="fact-badge-forced"
                                                        *ngIf="itemToSave.source_fond_honoraire === 'SINISTRE-REEL' || itemToSave.source_fond_honoraire === 'FORFAIT'">Forcé : Aucune</span>
                                                </label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Si source = Provision sinistres, préciser l'assiette : par garant, par famille ou par bénéficiaire. Si source = Forfait ou Sinistres réels, l'assiette est Aucune."
                                                    [disabled]="isDetailMode || itemToSave.source_fond_honoraire === 'SINISTRE-REEL' || itemToSave.source_fond_honoraire === 'FORFAIT'"
                                                    [(ngModel)]="itemToSave.assiete_fond_honoraire"
                                                    placeholder="Choisissez" name="assiete_fond_honoraire"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangeAssieteHonoraire()">
                                                    <ng-option *ngFor="let item of assietteDeFond"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Périodicité fond honoraire</label>
                                                <ng-select [appendTo]="'body'"
                                                    matTooltip="Fréquence d'établissement des factures d'honoraires."
                                                    [(ngModel)]="itemToSave.periodicite_fond_honoraire"
                                                    placeholder="Choisissez" name="periodicite_fond_honoraire"
                                                    [multiple]="false" [closeOnSelect]="true"
                                                    (change)="onChangePeriodiciteFondHonoraire()">
                                                    <ng-option *ngFor="let item of periodicite"
                                                        [value]="item.code">{{ item?.libelle }}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Taux -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-taux">
                                        <i class="fa fa-percent mr-2"></i> Taux
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Taux TVA (%)</label>
                                                <input
                                                    matTooltip="Taux de TVA applicable sur les factures d'honoraires."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Taux tva" autocomplete="off"
                                                    [(ngModel)]="itemToSave.taux_tva" name="taux_tva" type="text"
                                                    mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Taux commission primes (%)</label>
                                                <input
                                                    matTooltip="Si l'on choisit de calculer les honoraires par prime, on renseigne ici le taux à appliquer à la prime."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Taux commission prime" autocomplete="off"
                                                    [(ngModel)]="itemToSave.taux_commission_prime"
                                                    name="taux_commission_prime" type="text" mask="separator" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Estimations -->
                                <div class="fact-section">
                                    <div class="fact-section-header fact-estimation">
                                        <i class="fa fa-calculator mr-2"></i> Provision sinistre — Données de calcul
                                        <small class="ml-2 font-weight-normal" style="font-size:11px; opacity:0.85;">(petits garants : mutuelles, auto-financement)</small>
                                    </div>
                                    <div class="fact-section-body">
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Nombre de familles estimé</label>
                                                <input
                                                    matTooltip="Nombre total de familles couvertes par cette police."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Estimation nombre famille" autocomplete="off"
                                                    [(ngModel)]="itemToSave.nombre_famille_estime"
                                                    name="nombre_famille_estime" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Prime estimée par famille</label>
                                                <input
                                                    matTooltip="La prime approximative par famille, utilisée pour les calculs prévisionnels."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Estimation prime par famille" autocomplete="off"
                                                    [(ngModel)]="itemToSave.prime_par_famille_estime"
                                                    name="prime_par_famille_estime" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Nombre de bénéficiaires estimé</label>
                                                <input
                                                    matTooltip="Nombre total de bénéficiaires couverts par cette police."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Estimation nombre bénéficiaires" autocomplete="off"
                                                    [(ngModel)]="itemToSave.nombre_beneficiaires_estime"
                                                    name="nombre_beneficiaires_estime" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Prime estimée par bénéficiaire</label>
                                                <input
                                                    matTooltip="La prime approximative par bénéficiaire, utilisée pour les calculs prévisionnels."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Estimation prime par bénéficiaire" autocomplete="off"
                                                    [(ngModel)]="itemToSave.prime_par_beneficiaire_estime"
                                                    name="prime_par_beneficiaire_estime" type="text" mask="separator" />
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="fact-label">Montant provision garant</label>
                                                <input
                                                    matTooltip="La valeur de l'assiette est renseignée dans ce champ (montant de la provision, HT)."
                                                    [disabled]="isDetailMode" class="form-control form-control-sm"
                                                    placeholder="Montant provision garant" autocomplete="off"
                                                    [(ngModel)]="itemToSave.montant_provision_garant"
                                                    name="montant_provision_garant" type="text" mask="separator" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                  </mat-tab>

                </mat-tab-group>
                
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>